import { LoadableBackground } from '@confluence/loadable';

export const UpFlowCommerceRouterLoadable = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-UpFlowCommerceRouter" */ './UpFlowCommerceRouter'))
			.UpFlowCommerceRouter,
});
